<template>
  <div class="system-set">
    <el-dialog :visible.sync="dialogVisible">
      <div class="content">
        <div class="closeNav" @click="dialogVisible = false"
          >{{ $t('common.close') }}<img src="@/assets/images/common/close.png"
        /></div>
        <div class="tab-wrap">
          <div
            :class="{ active: activeName == $t('common.personInfo') }"
            @click="changeTab('common.personInfo')"
            >{{ $t('common.personInfo') }}</div
          >
          <div
            :class="{ active: activeName == $t('common.updatePwd') }"
            @click="changeTab('common.updatePwd')"
            >{{ $t('common.updatePwd') }}</div
          >
          <div></div>
        </div>
        <div class="formWrap">
          <div v-show="activeName == $t('common.personInfo')">
            <!-- 宠物 观察者 -->
            <el-form
              :class="{ 'form-view': lang == 'en' }"
              ref="form"
              :model="form"
              :rules="rules"
              v-if="loginType == 3 && appTheme == 'furCarer'"
            >
              <el-form-item :label="$t('common.name')">
                <el-input
                  v-model="form.memberName"
                  :placeholder="$t('common.pleaseEnter')"
                />
              </el-form-item>
              <div class="form-btn">
                <el-button
                  type="primary"
                  :loading="loading"
                  @click="handleProfileSubmit"
                  >{{ $t('common.confirm') }}</el-button
                >
              </div>
            </el-form>
            <!-- 宠物 用户 -->
            <el-form
              :class="{ 'form-view': lang == 'en' }"
              ref="form"
              :model="form"
              :rules="rules"
              v-if="loginType != 3 && appTheme == 'furCarer'"
            >
              <div class="formWrap-item">
                <div class="avatar-view">
                  <img
                    v-if="form.avatar || defaultAvatar"
                    class="avatar-view__img"
                    :src="form.avatar || defaultAvatar"
                    alt=""
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </div>
                <div class="editBox" @click="showCropper = true">
                  <img
                    class="editImg"
                    src="@/assets/images/common/edit.png"
                    alt=""
                  />
                  <p>{{ $t('common.upHead') }}</p>
                </div>
              </div>
              <!-- <el-form-item :label="$t('report.userCount')">
                <span class="inputWrap">{{ form.email }}</span>
              </el-form-item> -->
              <el-form-item :label="$t('pdfReport.petName')" prop="memberName">
                <el-input
                  v-model="form.memberName"
                  :placeholder="$t('common.pleaseEnter')"
                />
              </el-form-item>
              <el-form-item :label="$t('petDetail.variety')">
                <el-input
                  v-model="form.breed"
                  :placeholder="$t('common.pleaseEnter')"
                />
              </el-form-item>
              <el-form-item :label="$t('pdfReport.country')">
                <el-input
                  v-model="form.country"
                  disabled
                  :placeholder="$t('common.pleaseEnter')"
                />
              </el-form-item>

              <el-form-item :label="$t('pdfReport.birthday')">
                <el-date-picker
                  v-model="form.birthday"
                  type="date"
                  :placeholder="$t('common.pleaseSelect')"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  @change="changeBirthday"
                ></el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('pdfReport.age')">
                <el-input
                  v-model="form.age"
                  disabled
                  :placeholder="$t('common.pleaseEnter')"
                />
              </el-form-item>
              <el-form-item :label="$t('common.diabeteType')">
                <el-select
                  v-model="form.diabetesType"
                  :placeholder="$t('common.pleaseSelect')"
                  class="ele-fluid"
                  clearable
                >
                  <el-option :label="$t('common.noDiabetes')" :value="1" />
                  <el-option :label="$t('common.diabeteTypeI')" :value="2" />
                  <el-option :label="$t('common.diabeteTypeII')" :value="3" />
                  <!-- <el-option
                    :label="$t('common.diabeteGestational')"
                    :value="4"
                  />
                  <el-option :label="$t('common.diabeteSpecial')" :value="5" /> -->
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('eventList.weigt')">
                <el-input
                  v-model="form.weight"
                  :placeholder="$t('common.pleaseEnter')"
                >
                  <template slot="suffix">{{
                    $t('pdfReport.weightUnit')
                  }}</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('petDetail.type')">
                <el-select
                  v-model="form.insulinType"
                  :placeholder="$t('common.pleaseSelect')"
                  class="ele-fluid"
                  clearable
                >
                  <el-option :label="$t('petDetail.lente')" value="Lente" />
                  <el-option
                    :label="$t('petDetail.insulin')"
                    value="Insulin Glargine"
                  />
                  <el-option :label="$t('petDetail.pzi')" value="PZI" />
                  <el-option :label="$t('petDetail.nph')" value="NPH" />
                  <el-option :label="$t('petDetail.detemir')" value="Detemir" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('pdfReport.freq')">
                <el-input
                  v-model="form.insulinFreq"
                  :placeholder="$t('common.pleaseEnter')"
                >
                  <template slot="suffix">{{ $t('common.days') }}</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('pdfReport.insulinDose')">
                <el-input
                  v-model="form.insulinDose"
                  :placeholder="$t('common.pleaseEnter')"
                >
                  <template slot="suffix">U</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('pdfReport.registerType')">
                <el-select
                  v-model="form.syringeType"
                  :placeholder="$t('common.pleaseSelect')"
                  class="ele-fluid"
                  clearable
                >
                  <el-option :label="`U-40`" :value="40" />
                  <el-option :label="`U-100`" :value="100" />
                  <el-option :label="`U-500`" :value="500" />
                </el-select>
              </el-form-item>
              <div class="form-btn">
                <el-button
                  type="primary"
                  :loading="loading"
                  @click="handleProfileSubmit"
                  >{{ $t('common.confirm') }}</el-button
                >
              </div>
            </el-form>
            <!-- 人 -->
            <el-form
              :class="{ 'form-view': lang == 'en' }"
              ref="form"
              :model="form"
              :rules="rules"
              v-if="appTheme == 'hippo'"
            >
              <el-form-item :label="$t('common.name')" prop="memberName">
                <el-input
                  v-model="form.memberName"
                  :placeholder="$t('common.pleaseEnter')"
                />
              </el-form-item>
              <el-form-item :label="$t('pdfReport.birthday')">
                <el-date-picker
                  v-model="form.birthday"
                  type="date"
                  :placeholder="$t('common.pleaseSelect')"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  @change="changeBirthday"
                ></el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('common.diabeteType')">
                <el-select
                  v-model="form.diabetesType"
                  :placeholder="$t('common.pleaseSelect')"
                  class="ele-fluid"
                  clearable
                  @change="diabeteTypeChange"
                >
                  <el-option :label="$t('common.noDiabetes')" :value="1" />
                  <el-option :label="$t('common.diabeteTypeI')" :value="2" />
                  <el-option :label="$t('common.diabeteTypeII')" :value="3" />
                  <el-option
                    :label="$t('common.diabeteGestational')"
                    :value="4"
                  />
                  <el-option :label="$t('common.diabeteSpecial')" :value="5" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('common.gender')">
                <el-select
                  v-model="form.gender"
                  :placeholder="$t('common.pleaseSelect')"
                  class="ele-fluid"
                  clearable
                >
                  <el-option :label="$t('common.optionMale')" :value="1" />
                  <el-option :label="$t('common.optionFemale')" :value="2" />
                  <el-option :label="$t('common.optionUnknow')" :value="0" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('pdfReport.country')">
                <el-input
                  v-model="form.country"
                  disabled
                  :placeholder="$t('common.pleaseEnter')"
                />
              </el-form-item>
              <el-form-item
                :label="$t('common.dateOfDignose')"
                v-if="form.diabetesType && form.diabetesType != 1"
              >
                <el-date-picker
                  v-model="form.diabetesDiagnosisYear"
                  type="year"
                  :placeholder="$t('common.pleaseSelect')"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
              <div class="form-btn">
                <el-button
                  type="primary"
                  :loading="loading"
                  @click="handleProfileSubmit"
                  >{{ $t('common.confirm') }}</el-button
                >
              </div>
            </el-form>
          </div>
          <div v-show="activeName == $t('common.updatePwd')">
            <el-form
              :class="{ 'form-view': lang == 'en' }"
              ref="passForm"
              :model="passForm"
              :rules="passRules"
            >
              <el-form-item
                :label="$t('common.oldPassword')"
                prop="oldPassword"
              >
                <el-input
                  show-password
                  v-model="passForm.oldPassword"
                  :placeholder="$t('common.ruleMsgOldPassword')"
                />
              </el-form-item>
              <el-form-item
                :label="$t('common.newPassword')"
                prop="newPassword"
              >
                <el-input
                  show-password
                  v-model="passForm.newPassword"
                  :placeholder="$t('common.ruleMsgNewPassword')"
                />
              </el-form-item>
              <el-form-item
                :label="$t('common.confirmPassword')"
                prop="password2"
              >
                <el-input
                  show-password
                  v-model="passForm.password2"
                  :placeholder="$t('common.ruleMsgConfirmPassword')"
                />
              </el-form-item>
              <div class="form-btn" style="padding-top: 40px">
                <el-button
                  type="primary"
                  :loading="loading"
                  @click="handlePasswordSubmit"
                  >{{ $t('common.confirm') }}</el-button
                >
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 头像裁剪弹窗 -->
    <ele-cropper-dialog
      :show.sync="showCropper"
      :src="form.avatar || defaultAvatar"
      :lock-scroll="false"
      :to-blob="true"
      @crop="onCrop"
    />
  </div>
</template>

<script>
  import { uploadAvatar, updateUserInfo, updatePassword } from '@/api';
  import { rsaEncrypt, removeToken } from '@/utils/token-util';
  import { mapGetters, mapActions } from 'vuex';
  import { getFileAccessHttpUrl } from '@/utils/utils';
  import { Dayjs } from '@/utils/utils';
  import EleCropperDialog from 'ele-admin/packages/ele-cropper-dialog';
  import { getFollowerUserInfo } from '@/api/doctor/index';
  import { USER_LOGIN_TYPE } from '@/config/setting';

  export default {
    props: {
      showSet: {
        type: Boolean,
        default: false
      }
    },
    components: { EleCropperDialog },
    data() {
      return {
        // 主题
        appTheme: process.env.VUE_APP_THEME || 'furCarer',
        activeName: this.$t('common.personInfo'),
        imageUrl: '',
        loading: false,
        form: {
          memberName: '',
          breed: '',
          birthday: '',
          age: '',
          diabetesType: '',
          weight: '',
          insulinType: '',
          insulinFreq: '',
          insulinDose: '',
          syringeType: '',
          avatar: '',
          gender: '',
          diabetesDiagnosisYear: ''
        },
        rules: {
          memberName: [
            {
              required: true,
              message: this.$t('common.ruleMsgName'),
              trigger: 'blur'
            }
          ]
        },
        passForm: {
          oldPassword: '',
          newPassword: '',
          password2: ''
        },
        passRules: {
          oldPassword: [
            {
              required: true,
              message: this.$t('common.ruleMsgOldPassword'),
              trigger: 'blur'
            }
          ],
          newPassword: [
            {
              required: true,
              message: this.$t('common.ruleMsgNewPassword'),
              trigger: 'blur'
            }
          ],
          password2: [
            {
              required: true,
              trigger: 'blur',
              validator: (rule, value, callback) => {
                if (!value) {
                  return callback(
                    new Error(this.$t('common.ruleMsgConfirmPassword'))
                  );
                }
                if (value !== this.passForm.newPassword) {
                  return callback(
                    new Error(this.$t('common.passwordInconsistent'))
                  );
                }
                callback();
              }
            }
          ]
        },
        defaultAvatar:
          'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        showCropper: false,
        loginType: localStorage.getItem(USER_LOGIN_TYPE) || '2',
        pickerOptions: {
          disabledDate: (time) => {
            return time.getTime() > Date.now();
          }
        }
      };
    },
    computed: {
      dialogVisible: {
        get() {
          return this.showSet;
        },
        set(val) {
          this.$emit('update:showSet', val);
        }
      },
      ...mapGetters(['userInfo', 'lang'])
      // avatar() {
      //   return this.form.avatar
      //     ? getFileAccessHttpUrl(this.form.avatar)
      //     : this.defaultAvatar;
      // }
    },
    watch: {
      userInfo: {
        immediate: true,
        handler: function (val) {
          Object.assign(this.form, val);
        },
        deep: true
      }
    },
    methods: {
      ...mapActions(['fetchUserInfo', 'fetchUserInfos']),
      diabeteTypeChange(val) {
        this.form.diabetesDiagnosisYear = '';
      },
      /* 头像裁剪完成回调 */
      onCrop(res) {
        const file = new File([res], `file.${res.type.split('image/')[1]}`, {
          type: res.type
        });
        const formData = new FormData();
        formData.append('file', file);
        formData.append('subPath', 'memberAvatar');
        uploadAvatar(formData).then((res) => {
          if (res.code == 200) {
            this.form.avatar = res.item.fileUrl;
            this.showCropper = false;
          }
        });
      },
      getAge(birthDate) {
        const today = new Date();
        const birthdayThisYear = new Date(
          today.getFullYear(),
          birthDate.getMonth(),
          birthDate.getDate()
        );

        let age = today.getFullYear() - birthDate.getFullYear();
        if (today < birthdayThisYear) {
          age--; // 生日还没到今年，减去一岁
        }

        return age + 1;
      },
      changeBirthday(val) {
        if (val) {
          this.form.age = this.getAge(new Date(val));
        } else {
          this.form.age = '';
        }
      },
      changeTab(val) {
        this.activeName = this.$t(val);
      },
      handleAvatarSuccess(val) {},
      beforeAvatarUpload() {},
      save() {},
      /* 保存更改 */
      handleProfileSubmit() {
        this.$refs['form'].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.loading = true;
          let data = {};
          if (this.loginType == 3) {
            data.memberName = this.form.memberName;
          } else {
            if (this.appTheme == 'furCarer') {
              data = {
                memberName: this.form.memberName,
                breed: this.form.breed,
                birthday: this.form.birthday,
                age: this.form.age,
                diabetesType: this.form.diabetesType,
                weight: this.form.weight,
                insulinType: this.form.insulinType,
                insulinFreq: this.form.insulinFreq,
                insulinDose: this.form.insulinDose,
                syringeType: this.form.syringeType,
                avatar: this.form.avatar
              };
            } else {
              data = {
                memberName: this.form.memberName,
                birthday: this.form.birthday,
                diabetesType: this.form.diabetesType,
                gender: this.form.gender,
                diabetesDiagnosisYear: this.form.diabetesDiagnosisYear
              };
            }
          }
          updateUserInfo(data).then((res) => {
            this.loading = false;
            if (res.code === 200) {
              this.$message.success(this.$t('common.updateSuccessed'));
              this.$store.dispatch('user/fetchUserInfos');
            }
          });
        });
      },
      handlePasswordSubmit() {
        this.$refs['passForm'].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.loading = true;
          updatePassword({
            oldPassword: rsaEncrypt(this.passForm.oldPassword),
            newPassword: rsaEncrypt(this.passForm.newPassword)
          }).then((res) => {
            this.loading = false;
            if (res.code === 200) {
              this.$confirm(
                this.$t('common.passwordModifySuccessed'),
                this.$t('common.success'),
                {
                  type: 'success',
                  showClose: false,
                  showCancelButton: false,
                  closeOnPressEscape: false,
                  closeOnClickModal: false,
                  confirmButtonText: this.$t('common.ok')
                }
              ).then(() => {
                removeToken();
                location.replace('/login'); // 这样跳转避免再次登录重复注册动态路由
              });
            }
          });
        });
      }
    }
  };
</script>

<style lang="scss">
  .system-set {
    .el-dialog {
      margin: 0 !important;
      top: 50% !important;
      inset-inline-start: 50% !important;
      transform: translate(-50%, -50%) !important;
      width: 5.44791rem !important;
      border-radius: 0.0625rem !important;
      .el-dialog__header {
        display: none !important;
      }
      .el-dialog__body {
        padding: 0.35416rem 0.8rem 0.4375rem;
      }
    }
    .content {
      flex: 1;
      .closeNav {
        position: absolute;
        cursor: pointer;
        width: 100%;
        top: 23px;
        inset-inline-end: 15px;
        color: #5b6467;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        img {
          width: 15px;
          height: 15px;
          margin-inline-start: 16px;
        }
      }
      .tab-wrap {
        display: flex;
        padding: 0 61px;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 68px;
        div {
          font-family: 'RegularFont', 'Noto Sans', 'Arial', sans-serif;
          font-size: 20px;
          color: #5b6467;
          cursor: pointer;
        }
      }
      .formWrap {
        height: 500px;
        overflow-y: auto;
        padding: 0 0.4rem;
        .avatar-view {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          border: 1px solid #cecece;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          color: #cecece;
          overflow: hidden;
          &__img {
            width: 56px;
            height: 56px;
          }
        }
        &-item {
          display: flex;
          align-items: center;
          color: #90999b;
          font-family: 'RegularFont', 'Noto Sans', 'Arial', sans-serif;
          font-size: 16px;
          margin-bottom: 32px;
          .editBox {
            display: flex;
            align-items: center;
            cursor: pointer;
          }
          .editImg {
            margin: 0 7px 0 18px;
            width: 16px;
            height: 16px;
          }
          .label {
            width: 64px;
            color: #5b6467;
            margin-inline-end: 60px;
          }
        }
        .el-form-item {
          color: #5b6467;
          display: flex !important;
          align-items: center !important;
          font-size: 0.83333rem !important;
          .el-form-item__label {
            min-width: 120px !important;
            flex-shrink: 0 !important;
            text-align: left !important;
            margin-inline-end: 36px !important;
            padding: 0 !important;
          }
          .el-form-item__content {
            flex: 1;
            .el-input__inner {
              width: 100% !important;
              background: #f0f1f7 !important;
            }
          }
        }
        .form-view {
          .el-form-item .el-form-item__label {
            min-width: 140px !important;
          }
        }
        .el-form-item.is-required {
          .el-form-item__label::before {
            display: none !important;
          }
          .el-form-item__label::after {
            content: '\2022';
            display: inline-block;
            margin-inline-start: 0.0625rem;
          }
        }
        .form-btn {
          display: flex;
          justify-content: flex-end;
          .el-button {
            width: 1.0208rem !important;
            height: 0.208333rem !important;
            border-radius: 0.10416rem !important;
            font-size: 0.10416rem !important;
            line-height: 0.208333rem !important;
            padding: 0 !important;
            font-family: 'RegularFont', 'Noto Sans', 'Arial', sans-serif;
          }
        }
      }
    }
    .el-date-editor .el-icon-date:before {
      background: url('~@/assets/images/common/date-gray.png') no-repeat !important;
      background-size: 100% 100% !important;
    }
  }

  [dir='rtl'] {
    .system-set .el-dialog {
      margin: 0 !important;
      top: 50% !important;
      inset-inline-start: 0% !important;
      transform: translate(-50%, -50%) !important;
      width: 5.44791rem !important;
      border-radius: 0.0625rem !important;
    }
  }
</style>
